module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Medium-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Medium-webfont.ttf
// module id = 1635
// module chunks = 0